import React from "react";
import "./Organisation.css";
import { Col, Container, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import OrganisationTabbar from "./organisationTabbar/OrganisationTabbar";

class Organisation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { t } = this.props;

    return (
      <Container className="mt-3">
        <Row className="pageTitle">
          <Col>
            <h2>{t("Organisation.Title")}</h2>
          </Col>
        </Row>
        <Row>
          <Col>
            <OrganisationTabbar />
          </Col>
        </Row>
      </Container>
    );
  }
}

export default withTranslation()(Organisation);
